import { Component, inject, Input } from '@angular/core';
import { analytics } from '@app/events/segment/analytics';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-career-goal-dialog',
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
  ],
  templateUrl: './career-goal-dialog.component.html',
  styleUrl: './career-goal-dialog.component.css'
})
export class CareerGoalDialogComponent {
  @Input() showCloseIcon: boolean = false;
  readonly dialog = inject(MatDialog);
  constructor(private router: Router) {}

  onClickContinue() {
    analytics.track('Checklist Start Goal', { section: 'explore' });
    const currentUrl = this.router.url;
    if (currentUrl !== '/career-matches') {
      this.router.navigate(['/career-matches']);
    }
  }

  closeDialog() {
    this.dialog.closeAll ()
  }
}
